import { updateThemesBunch } from 'api/admin/businesses/businesses';

export const updateCommonTheme = async ({ initialTheme, newTheme }) => {
  const storeThemeIds = initialTheme.appliedTo
    .filter((theme) => !theme?.isBusinessTheme)
    .map(({ id }) => id);
  const businessThemeId = initialTheme.appliedTo.find((theme) => theme?.isBusinessTheme)?.id;
  await updateThemesBunch({
    storeThemeIds,
    businessThemeId,
    ...newTheme,
  });
};
